import { render, staticRenderFns } from "./RaceCardBarrierDraw.vue?vue&type=template&id=e998f140&scoped=true"
import script from "./RaceCardBarrierDraw.vue?vue&type=script&lang=js"
export * from "./RaceCardBarrierDraw.vue?vue&type=script&lang=js"
import style0 from "./RaceCardBarrierDraw.vue?vue&type=style&index=0&id=e998f140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e998f140",
  null
  
)

export default component.exports